import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, ArrowUpRight } from 'lucide-react';
import AuthorAvatar from '../components/common/AuthorAvatar';
import { useSiteSettings } from '../hooks/useSiteSettings';

const snakeTop = (
  <div className="relative mb-6 -mt-2">
    <svg className="w-full h-3" preserveAspectRatio="none" aria-hidden="true">
      <defs>
        <pattern id="team-snake" width="26" height="12" patternUnits="userSpaceOnUse">
          <path d="M0 0 L13 12 L26 0 Z" fill="#d1fae5" />
        </pattern>
      </defs>
      <rect width="100%" height="12" fill="url(#team-snake)" />
    </svg>
  </div>
);

function OurTeamPage() {
  const settings = useSiteSettings();
  const navigate = useNavigate();

  let team = [];
  try {
    const arr = JSON.parse(settings.team_members || '[]');
    if (Array.isArray(arr)) team = arr.filter((m) => m && String(m.name || '').trim());
  } catch {
    team = [];
  }

  const goProfile = (name) => {
    if (!name) return;
    navigate(`/profile/${encodeURIComponent(name)}`);
  };

  return (
    <main className="page max-w-[1240px] mx-auto px-5 pt-7 pb-[60px] w-full">
      {}
      <div className="flex flex-col items-center text-center mb-10">
        {settings.header_logo ? (
          <img src={settings.header_logo} alt="Kalo Jhola" className="h-20 w-auto object-contain mb-4" />
        ) : (
          <span className="font-display font-bold tracking-tight text-[30px] mb-3">
            KALO<em className="not-italic text-crimson">JHOLA</em>
          </span>
        )}
        <h1 className="font-display text-[26px] sm:text-[32px] font-bold">हाम्रो टिम</h1>
       
      </div>

      {team.length > 0 ? (
        <section className="mb-12">
          
          <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 w-full">
            {team.map((m, i) => (
              <div
                key={i}
                role="button"
                tabIndex={0}
                onClick={() => goProfile(m.name)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') goProfile(m.name); }}
                className="group bg-white border border-line rounded-2xl overflow-hidden shadow-sm hover:shadow-md hover:border-crimson transition-all flex flex-col items-center text-center p-5 cursor-pointer"
              >
                <span className="relative mb-3">
                  {m.photo ? (
                    <img src={m.photo} alt={m.name} className="w-24 h-24 rounded-full object-cover border-2 border-line group-hover:border-crimson transition-colors" />
                  ) : (
                    <AuthorAvatar name={m.name} size={96} />
                  )}
                  <span className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-crimson text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow">
                    <ArrowUpRight size={14} />
                  </span>
                </span>
                <p className="text-[15.5px] font-bold text-ink group-hover:text-crimson transition-colors">{m.name}</p>
                {m.role && <p className="text-[12.5px] font-semibold text-gold uppercase tracking-wide mt-0.5">{m.role}</p>}
                <div className="mt-3 flex flex-col gap-1.5 w-full">
                  {m.phone && (
                    <a href={`tel:${m.phone}`} onClick={(e) => e.stopPropagation()} className="inline-flex items-center justify-center gap-1.5 text-[12.5px] text-blue hover:text-crimson transition-colors">
                      {m.phone}
                    </a>
                  )}
                  {m.email && (
                    <a href={`mailto:${m.email}`} onClick={(e) => e.stopPropagation()} className="inline-flex items-center justify-center gap-1.5 text-[12.5px] text-blue hover:text-crimson transition-colors break-all">
                      {m.email}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      ) : (
        <div className="text-center py-16">
          <Users size={48} className="mx-auto text-muted mb-4" />
          <h3 className="font-display text-xl font-bold text-ink mb-2">टिम सदस्य थपिएको छैन</h3>
          <p className="text-muted">एडमिन प्यानलबाट टिम सदस्यहरू थप्नुहोस्।</p>
        </div>
      )}
    </main>
  );
}

export default OurTeamPage;